// extracted by mini-css-extract-plugin
export default {"container":"L5MsRE","img":"O_YB8N","content":"AAkaDQ"};